import { useRef, useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './Animation.css';
import { DotsThreeCircleIcon, XCircleIcon, HouseIcon, HouseSimpleIcon, GearIcon, UserIcon, MagnifyingGlassIcon, UserCircleIcon } from "@phosphor-icons/react";
import { FanMenuSnippet } from '../../snippets/FanMenu/FanMenu';
import { ScrollAnimationSnippet } from '../../snippets/AppbarSnippet/AppbarHtml';
import Card from '../Card/Card';
import { Copy } from 'lucide-react';

const FanMenu = () => {
  const copyContainer = useRef(null);
  const [scanAnimation, scanArea] = useState(false);
  const [menuVisible, setMenuVisible] = useState(false);


  const copySnippet = () => {
    if (copyContainer.current) {
      const range = document.createRange();
      range.selectNode(copyContainer.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      scanArea(true);
      setTimeout(() => scanArea(false), 1000);
    }
  };

  const htmlContainer = useRef(null);
  const [scanHtmlCont, htmlArea] = useState(false);
  const scanHtml = () => {
    if (htmlContainer.current) {
      const range = document.createRange();
      range.selectNode(htmlContainer.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      htmlArea(true);
      setTimeout(() => htmlArea(false), 1000);
    }
  };

  const [hideHeaderFooter, setHideHeaderFooter] = useState(false);

  useEffect(() => {
    const timer = setInterval(() => {
      setHideHeaderFooter(prev => !prev);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (

    <motion.div initial={{ y: 10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -10, opacity: 0 }} transition={{ duration: 0.2 }}
    >
      <div className='fan-menu>'>
        <div className="menu-section" id="menuGroup" >
          <div className="menu-wrapper-outer" style={{ display: menuVisible ? 'flex' : 'none' }}>
            <div className="menu-group group1">
              <span className="menu-item">
                <GearIcon size={24} color="#74788d" weight="duotone" className='icon' />
                <span className="menu-item-name">settings</span>
              </span>
              <span className="menu-item">
                <HouseSimpleIcon size={24} color="#74788d" weight="duotone" className='icon' />
                <span className="menu-item-name">home</span>
              </span>
            </div>
            <div className="menu-group group2">
              <span className="menu-item">
                <UserIcon size={24} color="#74788d" weight="duotone" className='icon' />
                <span className="menu-item-name">user</span>
              </span>
              <span className="menu-item">
                <HouseSimpleIcon size={24} color="#74788d" weight="duotone" className='icon' />
                <span className="menu-item-name">home</span>
              </span>
            </div>
            <div className="menu-group group3">
              <span className="menu-item">
                <HouseSimpleIcon size={24} color="#74788d" weight="duotone" className='icon' />
                <span className="menu-item-name">home</span>
              </span>
              <span className="menu-item">
                <HouseSimpleIcon size={24} color="#74788d" weight="duotone" className='icon' />
                <span className="menu-item-name">home</span>
              </span>
            </div>

          </div>
          <button className="sticky-button dynamicSticky" id="dynamicSticky" onClick={() => setMenuVisible(true)}
            style={{ display: menuVisible ? 'none' : 'block' }}>
            <DotsThreeCircleIcon size={36} color="#74788d" weight="duotone" className='icon' />
          </button>
          <button className="sticky-button dynamicSticky" id="dynamicStickyC" onClick={() => setMenuVisible(false)}
            style={{ display: menuVisible ? 'block' : 'none' }}>
            <XCircleIcon size={36} color="#74788d" weight="duotone" className='icon' />
          </button>
        </div>
        <div className={`center-container ${scanAnimation ? 'scanning' : ''}`}>

          <div className='snippet' ref={copyContainer}>
            <FanMenuSnippet />
          </div>
          <button aria-label="Copy Button" onClick={copySnippet}>
             <Copy />
          </button>
        </div>
      </div>
      <div className='scroll-animation-container carve-space-top-hefty'>
        <div className='heading-xlarge'> <u><b>scroll to 'hide / show' app bars</b> </u> </div>
        <div className='scroll-animation'>
          <div className={`dummy-header ${hideHeaderFooter ? 'hide-up' : ''}`}>
            <span className='dynamic-icelands'></span>
          </div>
          <div className='scroll-content'>
            <ul>
              {Array.from({ length: 60 }, (_, index) => (
                <li key={index}></li>
              ))}

            </ul>
          </div>
          <div className="swipe-container">
            <div className="swipe-dot"></div>
          </div>
          <div className={`dummy-footer ${hideHeaderFooter ? 'hide-down' : ''}`}>
            <HouseIcon size={20} color="#ffffff" weight="fill" />
            <UserCircleIcon size={20} color="#ffffff" weight="fill" />
            <MagnifyingGlassIcon size={20} color="#ffffff" weight="fill" />
          </div>
        </div>
      </div>
      <div className={`center-container ${scanHtmlCont ? 'scanning' : ''}`}>

        <div className='snippet' ref={htmlContainer}>
          <ScrollAnimationSnippet />
        </div>
        <button aria-label="Copy Button" onClick={scanHtml}>
           <Copy />
        </button>
      </div>

      {/* <div className={`center-container ${scanJSCont ? 'scanning' : ''}`}>
        <div className='snippet' ref={JsContainer}>
          <ScrollJsSnippet />
        </div>
        <button aria-label="Copy Button" onClick={scanJs}>
           <Copy />
        </button>
      </div> */}
    </motion.div>
  )
}

const FanMenuCard = () => {
  return (
    <Card
      CardTitle={<h2 className='heading-xlarge'><u> <b>fan menu animation</b> </u></h2>}
      CardBody={<FanMenu />}
    />
  )
}
export default FanMenuCard;